<template>
  <div
    id="preloader"
    :show="show"
  >
    <div id="inner" />
  </div>
</template>

<style scoped>
div#inner {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 998;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  overflow: visible;
  background: #333;
}

div#preloader {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  overflow: visible;
  background:
    url("https://66.media.tumblr.com/881d82e7b3645c5fafefe146955b891a/tumblr_opy997yh5I1qzt4vjo1_540.gif") no-repeat
    center center;
}
</style>

<script>
export default {
  name: "Loader",
  props: ["show"],
  data () {
    return {}
  }
}
</script>
